import { useQuery } from 'react-query';

import { userQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import { IPDNotification } from '../../types/PDNotification/PDNotification';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';
import useQSBuilder from '../../hooks/useQSBuilder';

export default function useUserNotifications(
  faultsOnly = false,
  applianceId?: string
) {
  const { get } = useApiHelper();
  const buildQs = useQSBuilder();

  const userNotifications = useQuery({
    queryKey: userQueryKeys.notifications({ faultsOnly, applianceId }),
    queryFn: () =>
      get<IDefaultResponseWithData<IPDNotification>>(
        `/v1/user/notifications${buildQs({
          faultsOnly,
          applianceId,
        })}`
      ).then((res) => res.data.data),
    refetchInterval: 15000, // Refetch every 15 seconds
  });

  return {
    userNotifications,
  };
}
